import { render, staticRenderFns } from "./AccessGrab.vue?vue&type=template&id=9842b45a&"
import script from "./AccessGrab.vue?vue&type=script&lang=js&"
export * from "./AccessGrab.vue?vue&type=script&lang=js&"
import style0 from "./AccessGrab.vue?vue&type=style&index=0&id=9842b45a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports